module.exports = __webpack_public_path__ + "img/Symbol_H4.eeaa8dab.png";